import * as React from 'react'
import { useDispatch } from 'react-redux'
import { setIsStored } from '../../../redux/slices/Alerts'
import { Box, Paper, Divider, Grid } from '@mui/material'
import { datasetFormik } from './datasetFormik'
import { Formik, Form } from 'formik'
import BottonInside from '../../BottonCustom/BottonInside'
import Textfield from '../../FormsUI/Textfield'
import Modal from '../../FormCreationModal'
import Select from '../../FormsUI/Select'
import { createCantonTenantRelation, updateCantonTenantRelation } from '../../../services/cantonTenantService'

const gridStyle = {
    mt: 0,
    width: '100%',
    ml: 0,
    textAlignLast: 'right',
    justifyContent: 'space-evenly',
    pr: 2,
}

const CantonTenantFormModal = (props, ref) => {
    const dispatch = useDispatch()
    const { initialValues, onClose, onSuccess } = props

    const [formik, setFormik] = React.useState(null)
    const [open, setOpen] = React.useState(false)

    const handleCancelAction = () => {
        setOpen(false)
        if (onClose) onClose()
    }

    const handleAddAction = async values => {
        let resultSave = { stored: true }
        const data = {
            id_canton: parseInt(values.id_canton, 10),
            id_tenant: parseInt(values.id_tenant, 10),
            orden: parseInt(values.orden, 10),
            es_principal: Boolean(parseInt(values.es_principal, 10)),
            habilitado: Boolean(parseInt(values.habilitado, 10)),
        }

        let response
        if (initialValues?.id) {
            response = await updateCantonTenantRelation(initialValues.id, data)
        } else {
            response = await createCantonTenantRelation(data)
        }

        if (!response.success) {
            resultSave = { stored: false, message: response?.message || 'Error al guardar asociación' }
        } else {
            if (onSuccess) onSuccess()
        }
        return resultSave
    }

    const otherPropsControl = {
        InputProps: { readOnly: false },
        variant: 'outlined',
    }

    React.useImperativeHandle(ref, () => ({ openModal: () => setOpen(true) }))

    React.useEffect(() => {
        if (props.open !== undefined) setOpen(props.open)
    }, [props.open])

    React.useEffect(() => {
        if (!open) return
        datasetFormik().then(variables => {
            if (initialValues) {
                // Mapping initial values
                // initialValues comes from row: { id, canton: {id, name}, tenant: {id, name}, orden, isPrimary, enabled }
                variables.INITIAL_FORMIK_STATE = {
                    id_canton: initialValues.canton?.id || '',
                    id_tenant: initialValues.tenant?.id || '',
                    orden: initialValues.orden || 0,
                    es_principal: initialValues.isPrimary ? 1 : 0,
                    habilitado: initialValues.enabled === false ? 0 : 1, // Default 1 (Activo)
                }
            }
            setFormik(variables)
        })
        return () => setFormik(null)
    }, [open, initialValues])

    if (!Boolean(formik)) return null

    return (
        <div>
            <Modal
                open={open}
                title={initialValues ? "Editar Asociación" : "Crear Asociación Cantón-Tenant"}
                description="Vincule un cantón con un tenant.">
                <Box>
                    <Formik
                        initialValues={{ ...formik?.INITIAL_FORMIK_STATE }}
                        validationSchema={formik?.FORM_VALIDATION}
                        onSubmit={async values => {
                            const itsStored = await handleAddAction(values)
                            handleCancelAction()
                            dispatch(setIsStored(itsStored))
                        }}>
                        <Form>
                            <Paper
                                style={{
                                    height: '100%',
                                    overflow: 'auto',
                                    borderRadius: 0,
                                }}>
                                <Divider />
                                <Grid container spacing={2} sx={{ ...gridStyle }}>
                                    {formik?.ITEMS_RELATION_FORMIK.map((o, i) => {
                                        const child = !o.options ? (
                                            <Textfield
                                                {...otherPropsControl}
                                                {...o}
                                                type={o.type || 'text'}
                                            />
                                        ) : (
                                            <Select key={`InPut-${i}`} {...o} {...otherPropsControl} />
                                        )
                                        return (
                                            <Grid
                                                key={`InPut-${i}`}
                                                item
                                                xs={o.x}
                                                sx={{ textAlignLast: 'center' }}>
                                                {child}
                                            </Grid>
                                        )
                                    })}
                                </Grid>
                                <Divider sx={{ pt: 2 }} />
                                <BottonInside enableButton={true} hdleButtonCancel={handleCancelAction} />
                            </Paper>
                        </Form>
                    </Formik>
                </Box>
            </Modal>
        </div>
    )
}

export default React.forwardRef(CantonTenantFormModal)
